import BaseModel from '../BaseModel';

export default class InterviewVideoQuestionVideo extends BaseModel {
  static entity = 'interviewVideoQuestionVideos';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      questionId: this.attr(null),
      type: this.string(null).nullable(),
      question: this.string(null).nullable(),
      categories: this.attr([]),
      interviewerId: this.attr(null),
      duration: this.number(null).nullable(),
      startTime: this.number(null).nullable(),
      speechStopTime: this.number(null).nullable(),
      stopTime: this.number(null).nullable(),
      recommended: this.boolean(false),
    };
  }

  static apiConfig = {
    actions: {
      async fetchAllByInterviewerId(interviewerId) {
        return this.get(`interviews/interviewers/${interviewerId}/questions`);
      },
      fetchAllByPresetIdAndInterviewerId(presetId, interviewerId) {
        return this.get(
          `interviews/presets/${presetId}/interviewers/${interviewerId}/questions`,
          { save: false },
        );
      },
    },
  }
}
